import { api } from '../../../shared/services/api/client';

export const sendCampaign = (type, title, subject, message, storeLogoUrl) => {
    return api.post('/merchant/marketing/send', {
        type,
        title,
        subject,
        message,
        storeLogoUrl,
    });
};

/**
 * Send campaign to selected customer emails (only opt-in customers are eligible).
 */
export const sendCustomerCampaign = (customerEmails, subject, title, message, storeLogoUrl) => {
    return api.post('/merchant/marketing/send-customers', {
        customerEmails,
        subject,
        title,
        message,
        storeLogoUrl,
    });
};

export const getUsage = () => {
    return api.get('/merchant/marketing/usage');
};

/**
 * Get customers (from customer-passes) for recipient selection.
 * Use response with marketing_opt_in to show only opt-in customers.
 */
export const getRecipients = () => {
    return api.get('/merchant/customer-passes');
};

/**
 * List available marketing audiences (e.g. top customers, inactive).
 */
export const getAudiences = () => {
    return api.get('/merchant/marketing/audiences');
};

/**
 * Get recipient list for an audience (opt-in only).
 */
export const getAudienceRecipients = (audienceKey) => {
    return api.get(`/merchant/marketing/audiences/${encodeURIComponent(audienceKey)}/recipients`);
};
